<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <!-- <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> -->
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/PlanandCases/CultureTour/CityWallProjectionPage/LightShowPageimg1.png"),
            title: " 象山影视城“唐宋奇妙夜”文化夜游活动火爆开启，云翰虹章技术支持助力创新体验",
            // description_no_1: `
            //    <strong class="bold-text">灯光投影秀</strong>
            // `,
            description_1: `
            2023年7月，为期三个多月的“唐宋奇妙夜”文化夜游活动在象山影视城正式开启。该活动一经推出便取得了极高的热度，无数游客慕名而来，前往名景点打卡并分享。

            象山影视城位于浙江省宁波市象山县，曾获2017年度旅游景区人气奖，并被评为国家4A级景区。自2005年开城以来，象山影视城先后拍摄了1500多部影视作品，其中不乏《神雕侠侣》等知名影视剧。本次“唐宋奇妙夜”由象山影视城推出，并由云翰虹章提供相关的技术服务。

            在“唐宋奇妙夜”活动中，每晚19：00-20：00在襄阳城景点准时演出的古城墙灯光投影秀广受追捧，单日人流量最高达到5.5万人。该灯光投影秀分为舞蹈编排与城墙投影两个部分，其中城墙投影部分采用了基于虚幻引擎的超写实CG动画制作，并由云翰虹章提供技术支持。此次灯光投影秀结合了传统的舞蹈表演与投影技术，展示了象山影视城制作的一系列知名影视剧（如：《琅琊榜》《庆余年》）中的经典场面，为观众带来了新奇的视听体验。

            作为此次活动的重要技术支持方，我们非常荣幸能够参与到这一项目中，并展示我们的技术实力与创意。未来，云翰虹章将继续与象山影视城携手，共同探索文化旅游领域的新内容，为观众带来更多精彩的视听体验。
              `,
            },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/PlanandCases/CultureTour/CityWallProjectionPage/LightShowPageimg1.png"),
            title:
              "Xiangshan Global Studios 'Tang and Song Wonderful Night' Light Projection Show",
            // description_no_1: `
            //    <strong class="bold-text">灯光投影秀</strong>
            // `,
            description_1:`
               In July 2023, the three-month ‘Tang and Song Wonderful Night’ cultural night tour activity was officially opened in Xiangshan Global Studios. The event achieved a high level of popularity as soon as it was launched, with countless tourists visiting the famous attractions and sharing their experiences.

              Xiangshan Global Studios, located in Xiangshan County, Ningbo City, Zhejiang Province, was awarded the 2017 Popularity Award for Tourist Attractions and was named a national 4A-level scenic spot. Since the opening of Xiangshan Global Studios in 2005, more than 1,500 film and television productions have been filmed, including many famous film and television dramas such as ‘The Divine Eagle’. The ‘Tang and Song Wonderful Night’ was launched by Xiangshan Global Studios, and Rosy Nebula provided the related technical services.

              In the ‘Tang and Song Wonderful Night’ activity, the light projection show on the ancient city wall, which is performed punctually from 19:00 to 20:00 every night at Xiangyang City Attractions, is widely sought after, with the highest one-day traffic reaching 55,000 people. The light projection show is divided into two parts: choreography and wall projection, of which the wall projection part adopts ultra-realistic CG animation based on the Unreal Engine, with technical support provided by Rosy Nebula. The light projection show combined traditional dance performances with projection technology to show classic scenes from a series of famous film and TV dramas produced by Xiangshan Global Studios (e.g. ‘Luangya Ranking’ and ‘Qingyu Nian’), which brought a novel audio-visual experience to the audience.

              As the key technical support provider of this event, we are honoured to participate in this project and demonstrate our technical strength and creativity. In the future, Rosy Nebula will continue to work hand in hand with Xiangshan Global Studios to explore new content in the field of culture and tourism, and bring more exciting audiovisual experiences to the audience.`,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>